import * as React from 'react';
import getReportingOption from '../store/store';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import ReportingOptionState from '../store/schema/ReportingOptionState';
import strings from 'owa-strings/owa-options-strings';
import { ChoiceGroup } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { getFallbackValueIfNull } from 'owa-options-core';
import { observer } from 'mobx-react';
import { setReportingState } from '../actions/internalActions';

const styles = require('./ReportingFull.scss');

export interface ReportingFullProps {
    optionState?: ReportingOptionState;
}

@observer
export default class ReportingFull extends React.Component<ReportingFullProps, {}> {
    render() {
        const optionState = getReportingOption();
        const userConfiguration = getUserConfiguration();
        const reportJunkSelected = getFallbackValueIfNull(
            optionState.reportJunkSelected,
            userConfiguration.UserOptions.ReportJunkSelected
        );
        const checkForReportJunkDialog = getFallbackValueIfNull(
            optionState.checkForReportJunkDialog,
            userConfiguration.UserOptions.CheckForReportJunkDialog
        );
        const reportingState = {
            reportJunkSelected: reportJunkSelected,
            checkForReportJunkDialog: checkForReportJunkDialog,
        };

        const key = this.mapOptionsToKey(reportingState);
        return (
            <>
                <div className={styles.reportingText}>{strings.options_junk_reportDescription}</div>
                <ChoiceGroup
                    selectedKey={key}
                    options={[
                        {
                            key: 'A',
                            text: strings.options_junk_reportOptionAsk,
                        },
                        {
                            key: 'B',
                            text: strings.options_junk_reportOptionAlways,
                        },
                        {
                            key: 'C',
                            text: strings.options_junk_reportNever,
                        },
                    ]}
                    onChange={this.onChange}
                    label={strings.options_junk_reportLabel}
                    required={false}
                />
            </>
        );
    }
    private onChange = (ev: React.FormEvent<HTMLInputElement>, option: any): void => {
        const reportingState = this.mapKeyToOptions(option.key);
        setReportingState(reportingState);
    };

    private mapOptionsToKey(reportingState: ReportingOptionState): string {
        if (!reportingState.checkForReportJunkDialog) {
            return 'A'; // Ask me before sending reports
        } else if (reportingState.reportJunkSelected && reportingState.checkForReportJunkDialog) {
            return 'B'; // Automatically send reports
        } else if (!reportingState.reportJunkSelected && reportingState.checkForReportJunkDialog) {
            return 'C'; // Never send reports
        }
        throw new Error('Invalid reportingState: ' + JSON.stringify(reportingState));
    }

    private mapKeyToOptions(key: string): ReportingOptionState {
        let reportJunkSelected;
        let checkForReportJunkDialog;

        switch (key) {
            case 'A': // Ask me before sending reports
                reportJunkSelected = getUserConfiguration().UserOptions.ReportJunkSelected;
                checkForReportJunkDialog = false;
                break;
            case 'B': // Automatically send reports
                reportJunkSelected = true;
                checkForReportJunkDialog = true;
                break;
            case 'C': // Never send reports
                reportJunkSelected = false;
                checkForReportJunkDialog = true;
                break;
        }

        const returnState = {
            reportJunkSelected: reportJunkSelected,
            checkForReportJunkDialog: checkForReportJunkDialog,
        };
        return returnState;
    }
}
